<template>
  <div :class="name">
    <div :class="`${name}__content`">
      <skeleton-basic width="204px" height="22px" style="margin-bottom: 10px;" />
      <skeleton-basic v-for="i in adTypeListCounts" :key="i" :class="`${name}__type`" height="14px" width="204px" />
    </div>
    <div :class="`${name}__content`">
      <skeleton-basic width="204px" height="22px" style="margin-bottom: 10px;" />
      <skeleton-basic v-for="i in adTypeListCounts" :key="i" :class="`${name}__type`" height="14px" width="204px" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';

const name = 'ttam-adgroup-right-side-bar-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    const adTypeListCounts = 5;
    return {
      name,
      adTypeListCounts,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-adgroup-right-side-bar-skeleton';
.#{$name} {
  &__content {
    line-height: 22;
    padding: 14px 18px;
    background-color: #fff;
    margin-bottom: 16px;
  }
  &__type {
    margin-bottom: 6px;
  }
}
</style>
